import React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { Button } from 'Views/Components/Button/Button';

export interface RemoveLineItemButtonProps {
	onClick: () => void;
	disabled?: boolean;
	/** Extra classes — e.g. a caller's own scoped class for layout tweaks. */
	className?: string;
	/** Accessible name. The button renders an icon only, so without this it has no label. */
	ariaLabel?: string;
	testId?: string;
}

/**
 * The cross that clears a removable line item — a voucher, a discount, a fee.
 *
 * Extracted so the booking wizard's cart and the anytime-ticket / parking review step share one
 * definition rather than each rendering their own cross. The base look lives on
 * `.remove-line-item__btn` (a top-level class, so it works outside the wizard's
 * `.cart-line-item__wrap` scope); callers may layer their own class on top.
 */
function RemoveLineItemButton({ onClick, disabled, className, ariaLabel, testId }: RemoveLineItemButtonProps) {
	return (
		<Button
			className={classNames('remove-line-item__btn', className)}
			icon={{ icon: 'cross', iconPos: 'icon-top' }}
			disabled={disabled}
			onClick={onClick}
			buttonProps={
				{
					'aria-label': ariaLabel ?? 'Remove',
					...(testId ? { 'data-test-id': testId } : {}),
				} as React.ButtonHTMLAttributes<Element>
			}
		/>
	);
}

export default observer(RemoveLineItemButton);
